/* eslint-disable react/display-name */
import * as React from 'react';

const Clock = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      d="M8,16a8,8,0,1,1,8-8A8,8,0,0,1,8,16Zm0-1.9A6.1,6.1,0,0,0,8,1.9,6.12,6.12,0,0,0,1.9,8,6.19,6.19,0,0,0,8,14.1ZM9.1,8.8a.79.79,0,0,1-.8.5H4.7c-.4.1-.8-.3-.8-.8V8.4a.88.88,0,0,1,.8-.9H7.6L8.8,4a1,1,0,0,1,1.1-.6H10a.86.86,0,0,1,.6,1.1l-1.3,4c-.1.1-.1.2-.2.3Z"
      style={{ fill: 'inherit', fillRule: 'evenodd' }}
    />
  </svg>
);

export default Clock;
